import { render, staticRenderFns } from "./index-v1.0.vue?vue&type=template&id=f2bdbb30&scoped=true&"
import script from "./index-v1.0.vue?vue&type=script&lang=js&"
export * from "./index-v1.0.vue?vue&type=script&lang=js&"
import style0 from "./index-v1.0.vue?vue&type=style&index=0&id=f2bdbb30&lang=less&scoped=true&"
import style1 from "./index-v1.0.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bdbb30",
  null
  
)

export default component.exports